module.exports = __webpack_public_path__ + "static/media/mobile_game_item.5ff3811c.png";